import script from "./CandidatePromptDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidatePromptDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CandidatePromptDialog.vue?vue&type=style&index=0&id=7254fcba&lang=scss"

const __exports__ = script;

export default __exports__